import baMessages from '../locales/bs_BA.json';

const BhLang = {
  messages: {
    ...baMessages,
  },
  locale: 'bs-BA',
};
export default BhLang;
